import React, { useState } from 'react';
import JumpToDialog from './JumpToDialog';

// Previous/Next live in VerseDisplay, as arrows flanking the verse itself.
// This row keeps only the action they don't cover.
const NavigationControls = () => {
  const [showJumpDialog, setShowJumpDialog] = useState(false);

  return (
    <>
      <div className="flex justify-center mt-6">
        <button
          onClick={() => setShowJumpDialog(true)}
          className="px-6 py-2 bg-gold text-deep-green rounded-md shadow hover:bg-light-gold focus-visible:bg-light-gold transition-colors font-lato"
        >
          Jump to Verse
        </button>
      </div>

      <JumpToDialog
        isOpen={showJumpDialog}
        onClose={() => setShowJumpDialog(false)}
      />
    </>
  );
};

export default NavigationControls;
